import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { hashToken } from '@/lib/inviteToken';

export interface TokenValidation {
  valid: boolean;
  reason?: 'invalid' | 'expired' | 'revoked' | 'completed';
  inviteId?: string;
  candidateId?: string;
  processId?: string;
  companyId?: string;
}

export async function validateCandidateToken(token: string): Promise<TokenValidation> {
  const tokenHash = await hashToken(token);
  const lookupSnap = await getDoc(doc(db, 'inviteTokenLookup', tokenHash));
  if (!lookupSnap.exists()) return { valid: false, reason: 'invalid' };
  const d = lookupSnap.data();
  if (new Date(d.tokenExpiresAt) < new Date()) return { valid: false, reason: 'expired' };
  const candidateSnap = await getDoc(doc(db, 'candidates', d.candidateId));
  if (!candidateSnap.exists()) return { valid: false, reason: 'invalid' };
  const cand = candidateSnap.data();
  if (cand.status === 'completed') return { valid: false, reason: 'completed' };
  return {
    valid: true,
    inviteId: d.inviteId,
    candidateId: d.candidateId,
    processId: d.processId,
    companyId: d.companyId,
  };
}
